export default __webpack_public_path__ + "static/media/celular.e2c163fc.png";